import UpdateItemAdjustment from "../../../../components/@documents/item_adjustments/UpdateItemAdjustment";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemAdjustmentUpdatePage() {

    return (
        <UpdateItemAdjustment 
            routeType={routeTypes.admin}
        />
    )
}